import { FadeIn } from "../motion/Reveal";
import { CountUp } from "../motion/CountUp";
import { SectionLabel } from "../motion/SectionLabel";
import { TRACTION, GEN } from "../../data/content";

export const Traction = () => {
  return (
    <section
      id="traction"
      data-testid="traction-section"
      className="relative min-h-screen flex flex-col justify-center py-28 md:py-32 px-6 md:px-10 overflow-hidden"
    >
      {/* Imposing full-bleed backdrop */}
      <div className="pointer-events-none absolute inset-0 -z-0">
        <img
          src={GEN.traction}
          alt=""
          aria-hidden
          className="h-full w-full object-cover opacity-[0.28]"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-[#050505]/85 to-[#050505]" />
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto w-full">
        <div className="max-w-3xl mb-16">
          <SectionLabel>{TRACTION.label}</SectionLabel>
          <FadeIn delay={0.1}>
            <h2 className="mt-6 font-display font-bold text-white text-5xl sm:text-6xl lg:text-7xl tracking-tight">
              {TRACTION.heading}
            </h2>
          </FadeIn>
          <FadeIn delay={0.2}>
            <p className="mt-6 font-body text-lg text-neutral-400 leading-relaxed font-light">
              {TRACTION.lead}
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.1}>
          <span className="font-body text-xs uppercase tracking-[0.3em] text-neutral-500">
            {TRACTION.kicker}
          </span>
        </FadeIn>

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 border-t border-l border-white/10">
          {TRACTION.stats.map((s, i) => (
            <FadeIn
              key={s.label}
              delay={(i % 3) * 0.08}
              className={`${s.span} border-b border-r border-white/10 p-8 md:p-10`}
              data-testid={`traction-stat-${i}`}
            >
              <div className="font-display font-extrabold text-6xl md:text-7xl tracking-tight text-gradient-warm">
                {s.display ? (
                  s.display
                ) : (
                  <CountUp value={s.value} suffix={s.suffix} />
                )}
              </div>
              <p className="mt-4 font-body text-neutral-400 text-sm leading-relaxed max-w-[240px]">
                {s.label}
              </p>
            </FadeIn>
          ))}
        </div>

        <FadeIn delay={0.15}>
          <div className="mt-16">
            {TRACTION.closer.map((line, i) => (
              <p
                key={i}
                className={`font-display font-medium text-2xl md:text-4xl tracking-tight ${
                  i === 1 ? "text-white" : "text-neutral-500"
                }`}
              >
                {line}
              </p>
            ))}
          </div>
        </FadeIn>
      </div>
    </section>
  );
};
